<template>
  <app-layout>
    <template #header>
      <div class="flex justify-between  ">
        <div>
          <h2 class="font-semibold text-xl text-gray-800 leading-tight">
            Usuário
          </h2>
        </div>
        <div class="float-right">
          <div class="grid gap-4 grid-flow-col auto-cols-max">
            <div>
              <inertia-link :href="route('user.create')">Novo</inertia-link>
            </div>
          </div>
        </div>
      </div>

    </template>

    <div class="max-w-7xl mx-auto py-2 sm:px-2 lg:px-2">
      <div class="md:grid">
        <div class="py-2 flex justify-content-start">
          <div>
            <span class="text-xl text-gray-500">Lista</span>
          </div>
          <div class="ml-auto flex">

            <legenda class="h-6 self-center mr-12"></legenda>
            <search-button
              :campos="campos"
              :filter-initial="initialFilters"
              @apply="aplicarFiltro"
            ></search-button>
          </div>

        </div>
        <div class="bg-white shadow rounded w-full ">
          <table
            v-loading.body="isLoading"
            class="text-left w-full border-collapse"
          >
            <thead class="bg-gray-700 text-white">
              <tr>
                <th :class="headerTable">
                  #
                </th>
                <th :class="headerTable">Nome</th>
                <th :class="headerTable">Email</th>
                <th :class="headerTable">#</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="user in users.data"
                :key="user.id"
                class=" hover:bg-orange-100 bg-white even:bg-gray-100"
              >
                <td :class="rowTableStyle">
                  <status :status="user.state">
                    {{user.id}}
                  </status>

                </td>
                <td :class="rowTableStyle">
                  {{user.name}}
                </td>
                <td :class="rowTableStyle">
                  {{user.email}}
                </td>
                <td class="py-2 px-6 border-b border-grey-light text-xs">
                  <div class="flex space-x-4">
                    <div>
                      <inertia-link :href="route('user.edit', user.id)">
                        <i class="fas fa-pen cursor-pointer"></i>
                      </inertia-link>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="flex  justify-center mt-3">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="users.total"
            :page-size="users.per_page"
            :current-page="users.current_page"
            @current-change="changePage"
            :hide-on-single-page="true"
          >
          </el-pagination>
        </div>
      </div>
    </div>

  </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout';
import Status from './Status';
import Legenda from './Legenda';
import SearchButton from '@/Components/SearchButton';


export default {
  props: ['users', 'initialFilters'],
  components: {
    AppLayout,
    Status,
    Legenda,
    SearchButton,
  },
  data() {
    const campos = {
      name: {
        label: 'Nome',
        field: 'name',
        type: 'input',
        config: {
        }
      },
      email: {
        label: 'Email',
        field: 'email',
        type: 'input',
        config: {
        }
      },

    };

    return {
      isLoading: false,
      currentPage: 1,
      totalRegistros: 0,
      form: {},
      headerTable: 'py-2 px-6 bg-grey-lightest font-bold text-sm text-grey-dark border-b border-grey-light',
      rowTableStyle: 'py-2 px-6 border-b border-grey-light text-xs whitespace-nowrap overflow-x-auto',
      campos
    }
  },
  methods: {
    aplicarFiltro(filters) {
      this.isLoading = true;
      this.$inertia.get(
        this.route('user.index', {
          filters: filters,
          'page': this.page
        })
        , {}, { replace: true });

    },
    changePage(event) {
      this.isLoading = true;
      this.$inertia.get(
        this.route('user.index', {
          filters: this.initialFilters,
          'page': event
        })
        , {}, { replace: true });
    },

  }
}
</script>
